<template>

    <div class="persons-table">

        <div class="field has-addons">

            <div class="control is-expanded">

                <input type="text" v-model="keyword" ref="person_search" placeholder="Search/Select/Create..." class="input">

            </div>

            <div class="control">

                <button class="button is-info user-table-action-button" @click.prevent="add">ADD</button>

            </div>

        </div>

        <div class="field has-addons">

            <div class="control is-expanded" style="display:flex;">

                <b-select placeholder="Select a character" expanded v-model="selectedRole">

                    <option :value="role" v-for="(role, key) in roles">{{ role }}</option>

                </b-select>

                <!-- <b-autocomplete v-model="selectedRole" class="is-expanded" :data="roles"></b-autocomplete> -->

                <div class="control">

                    <b-button type="is-info" class="user-table-action-button" @click="updateRole" :disabled="(!selectedRole || !checkedUsers.length) || !actionAddRole">

                        ACTION

                    </b-button>

                </div>

            </div>

        </div>


        <div style="padding:10px;">

            <span v-if="$parent.canManageUsers">
                
                <b-checkbox v-model="checkedAllUsers"></b-checkbox> <span style="position: absolute;margin-top: 0px;margin-left: 15px;font-weight: bold;">Check All</span>
                
            </span>

            <span v-else>

                Fullname
            
            </span>
        
            <div style="float:right; font-weight:bold; margin-right: 40px; margin-top: 4px;">
            
                <b-checkbox v-model="archived">Include Archived</b-checkbox>
                
            </div>

            
        </div>

        <div class="scrollable" style="height:calc(90vh - 50px - 126px); padding: 0; overflow: scroll;">

            <table :class="'table b-table' + (loading ? ' is-loading' : '')" style="width:100%;">

<!--                 <tr>

                    <template v-if="$parent.canManageUsers">

                        <th class="is-narrow">

                            <b-checkbox v-model="checkedAllUsers"></b-checkbox>

                        </th>

                        <th colspan="2" class="is-narrow">

                            Check all

                        </th>

                    </template>

                    <template v-else>

                        <th colspan="2" class="is-narrow">

                            Fullname

                        </th>

                    </template>

                </tr> -->

                <tr v-for="user in filteredUsers" :key="user.id" 

                @click="$emit('update:selected', user)"
                :id="selected && selected.id === user.id ? 'active-person' : ''"
                :class="selected && selected.id === user.id ? 'active-person' : ''">

                    <td  class="is-narrow"  v-if="$parent.canManageUsers">

                        <b-checkbox :native-value="user.id" v-model="checkedUsers" class="person-checkbox"></b-checkbox>

                    </td>

                    <td class="is-clipped" style="border-right:0">

                      <strike v-if="user.archivedAt != null">{{ user.fullName }}</strike>

                      <span v-else>{{ user.fullName }}</span>

                      <!-- <div class="role-div">

                        <span class="tag is-dark" v-for="(role, key) in user.roles" @click="keyword = role.name">{{ role.name }}</span>

                      </div> -->

                    </td>

                    <td class="is-narrow" style="border-left:0; text-align:right;">
            
                        <i class="fa fa-star admin-star-role" v-if="hasAdminRole(user.roles)"></i>

                        <!-- <b-button style="margin-right:10px;" v-if="hasAdminRole(user.roles)"></b-button> -->

                        <!-- <b-button :type="{ 'is-link': selected && selected.id === user.id }" class="is-light" @click="$emit('update:selected', user)">

                            <span class="icon">

                                <i class="fa fa-pencil"></i>

                            </span>

                        </b-button> -->

                    </td>

                </tr>

            </table>

        </div>

    </div>

</template>

<script>

    import BaseTable from "@/components/partials/BaseTable";

    import Roles from "@/helpers/roles";

    import Permissions from "@/helpers/permissions";

    import { AuthService } from "@/services/auth.service";

    import { UserService } from "@/services/user.service";

    import { startRouteMixin } from "@/mixins/startRouteMixin";

    import { JsonDenormalizer } from "@/helpers/JsonDenormalizer";

    import { RoleService } from "@/services/role.service";

    export default {

        columns: [{
            field: "name",
            label: "",
            meta: {
                rowSlot: "rowFullName" }
            },
            {
                field: "actions",
                label: "",
                width: "150",
                meta: {
                    owSlot: "rowActions",
                    class: "has-text-centered"
                }
            }
        ],
        perPage: 1000,
        props: {
            organizationId: {
                type: Number | String,
                required: true
            },
            create: {
                type: Boolean,
            },
            // archivedAt: {
            //     required: true
            // },
            selected: {
            type: Object,
                default: () => {}
            },
            height: {
                type: Number,
                default: 500
            },
            enableApply: {
                type: Boolean
            }
        },
        components: {
            BaseTable
        },
        mixins: [startRouteMixin],

        data: () => ({

            authService: AuthService,

            userService: UserService,

            scrollableElement: null,

            loading: true,

            teleporting: null,

            users: [],

            checkedAllUsers: false,

            checkedUsers: [],

            roles: [],

            selectedRole: '',

            keyword: '',

            callDefault: true,

            actionAddRole: false,

            archived: false,

        }),

        computed: {

            isSuperAdmin() {

                return this.$store.getters["Auth/hasRole"](Roles.SUPERADMIN);

            },

            usersId() {

                return this.users.map(user => user.id)

            },

            filteredUsers() {

                let active = this.users.filter(element => element.archivedAt == null);

                active = this.sortUsers(active);

                let archived = this.users.filter(element => element.archivedAt != null);

                archived = this.sortUsers(archived);

                let users =  active.concat(archived);

                let keyword = this.keyword;

                return users.filter(user => {

                    let roleExist = false;

                    user.roles.forEach(role => {

                        if (roleExist == false) {

                            roleExist = role.name.toLowerCase().includes(keyword.toLowerCase());

                        }

                    });

                    let nameExist = user.fullName.toLowerCase().includes(keyword.toLowerCase());

                    return nameExist || roleExist;

                });

            },

        },

        watch: {

            // archivedAt(){
            archived(){

                this.$nextTick(() => {

                    this.fetch();

                })

            },

            checkedAllUsers(value) {

                this.checkedUsers = value ? this.usersId : [];

            },

            checkedUsers(value) {

                this.$emit("update:enableApply", value.length ? true : false);

            },

            users(value) {

                this.$emit('update:create', value.length ? false : true);

                if (this.callDefault) {

                    this.defaultPerson();

                }

            },

            organizationId() {

                this.fetch();
                this.$refs.person_search.focus();

            },


            selectedRole(value){

                this.actionAddRole = this.roles.find(element => element.toLowerCase() == value.toLowerCase()) ? true : false;

            }


        },

        methods: {

            async fetch() {

                this.loading = true;

                let params = {
                        order_by:'asc', sort_by: 'desc', 
                        per_page: 1000, page: 1, 
                        firmId: this.organizationId,
                        filter_by:'first_name', order_by:'asc', 
                        includes: 'permissions,roles,tags,firmAssociations,firmAssociations.firm,attributes'
                    };

                if (!this.archived) {
                    params.archived = false;
                }

                await this.userService.all(params)

                    .then(response => {

                        this.users = JsonDenormalizer.denormalize(response);

                        this.loading = false;

                        this.$emit("fetch", this.users);

                });

                if (this.selected) {

                    this.$emit("update:selected", this.users.find(element => element.id == this.selected.id));

                }
            },

            updateRole(role) {

                UserService.updateRole({role:this.selectedRole, users: this.checkedUsers}).then(response => {

                    this.$buefy.toast.open({

                        message: "Personel Role Updated",

                        type: "is-info",

                        position: "is-top-right"

                    });

                    this.fetch();

                });

            },

            sortRole(roles) {

                const sortRole = roles;

                return sortRole.sort((a, b) => {

                    var x = a.name.toLowerCase(), y = b.name.toLowerCase();

                    return x < y ? -1 : x > y ? 1 : 0;

                });

            },

            async teleport(id) {

                this.teleporting = id;

                try {
                    const token = await this.authService
                    .teleport({id})
                    .then(response => response.data.token);
                    this.$store.dispatch("Auth/setToken", token);
                    this.navigateToStartRoute();
                } catch (err) {
                    //
                }

            // this.teleporting = null;

            },

            onSelect(selected) {

                this.$emit("update:selected", selected);

            },

            canTeleportAs(user) {

            // return (this.isSuperAdmin
            //   || (this.$store.state.Auth.user.firmId == user.firmId
            //     && this.$store.getters["Auth/hasPermission"](Permissions.CAN_TELEPORT_AS_COLLEAGUE)));

                return this.isSuperAdmin || this.$store.getters["Auth/hasPermission"](Permissions.CAN_TELEPORT_AS_COLLEAGUE);

            },

            async fetchRoles() {

                await RoleService.all({type: 'person'}).then(response => {

                    return this.roles = response.data.map(role => role.attributes.name)

                });

            },

            defaultPerson() {

                this.$emit('update:selected', this.users.find(element => element.id == this.$store.state.Auth.user.id))
                
                // Selected table row must be visible on page load
                this.$nextTick(() => {
                    const row = document.getElementById("active-person");
                    if (row) row.scrollIntoView()
                });

                this.callDefault = false;

            },

            add() {

                this.$parent.addUser(this.keyword);

                this.$emit('update:selected', null)

                

            },

            sortUsers(users) {

                // console.log(users);

                const sortUsers = users;

                return sortUsers.sort((a, b) => {

                    var x = a.fullName.toLowerCase(), y = b.fullName.toLowerCase();

                    return x < y ? -1 : x > y ? 1 : 0;

                });

            },

            hasAdminRole(roles) {

                return roles.find(element => element.name.toLowerCase() == 'admin');

            }


        },

        mounted() {

            this.scrollableElement = this.$refs.scrollableElement;

            this.fetch();

            this.fetchRoles();

        }

    };

</script>

<style scoped>

    .card-content {
        padding: 0;
    }

    .role-div {
        float: right;
    }

    .role-div .tag {
        cursor: pointer;
    }

    .role-div .tag {
        margin-left: 3px;
    }

    .search-input {
        margin-bottom: 10px;
        width: 50%;
    }

    .user-table-action-button{
        width: 65px;
    }

    .admin-star-role{
        color: #0099ff;
        padding: 1px 25px;
        margin-top: 6px;
        font-size: 15px;
    }

    .active-person{
        
        background-color: #3273dc;
        
        color: white;


    }

    .active-person .admin-star-role{

        color: white;
    
    }

</style>


// WEBPACK FOOTER //
// src/components/pages/Organization/persons/userTable.vue